import {post} from './httpBase';
//根据id获取订单详情
export function getdetailes(params) {
    return post('/order/cityorder/getdetailes', params)
}
//城内待派单列表
export function dispatcherList(params) {
    return post('/order/cityorder/dispatchercityorderlist', params)
}
//城内业务工作台
export function cityCispatcher(params) {
    return post('/order/cityorder/workingofdispatcher', params)
}
//发单
export function orderSend(params) {
    return post('/order/cityorder/dispatchercityordersend', params)
}
//城内选择司机列表
export function cityDriverList(params) {
    return post('/order/cityorder/matchingdriverbycityorderid', params)
}
//选择司机派单
export function selectCityDriver(params) {
    return post('/order/cityorder/sendorderagain', params)
}
//关闭订单如果有手续费，获取手续费详情
export function cancleCityInfo(params) {
    return post('/order/cityorder/canclecityorderofadmin', params)
}
//待出行订单详情
export function tobepayInfo(params) {
    return post('/order/cityorder/getchargeofdriverbyid', params)
}
//发送账单
export function cancleCity(params) {
    return post('/order/cityorder/canclecityorder', params)
}


// WEBPACK FOOTER //
// ./src/service/cityService.js